
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="back()"></ion-back-button>
    </ion-buttons>
    <ion-title>Zeitraum auswählen</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-radio-group [(ngModel)]="selectedDate.value" mode="md">
    <ion-item *ngFor="let item of selectItems">
      <ion-radio slot="start" [value]="item.value" labelPlacement="end">{{item.name}}</ion-radio>
    </ion-item>
  </ion-radio-group>

  <div id="custom-date">
    <div>
      <div>Start:</div>
      <ion-datetime-button slot="start" datetime="customDateStart" mode="md" [disabled]="selectedDate.value != 'custom'"></ion-datetime-button>
      <ion-modal [keepContentsMounted]="true">
        <ng-template>
          <ion-datetime presentation="date" locale="de-DE" id="customDateStart" [(ngModel)]="customDateStart"></ion-datetime>
        </ng-template>
      </ion-modal>
    </div>
    <div>
      <div>Ende:</div>
      <ion-datetime-button slot="start" datetime="customDateEnd" mode="md" [disabled]="selectedDate.value != 'custom'"></ion-datetime-button>
      <ion-modal [keepContentsMounted]="true">
        <ng-template>
          <ion-datetime presentation="date" locale="de-DE" id="customDateEnd" [(ngModel)]="customDateEnd"></ion-datetime>
        </ng-template>
      </ion-modal>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding">
    <ion-button mode="ios" (click)="save()">
      Speichern & Anwenden
    </ion-button>
  </ion-toolbar>
</ion-footer>